import { render, staticRenderFns } from "./board.vue?vue&type=template&id=483bf53a&scoped=true&"
import script from "./board.vue?vue&type=script&lang=ts&"
export * from "./board.vue?vue&type=script&lang=ts&"
import style0 from "./board.vue?vue&type=style&index=0&id=483bf53a&prod&lang=scss&"
import style1 from "./board.vue?vue&type=style&index=1&id=483bf53a&prod&lang=scss&scoped=true&"
import style2 from "./board.vue?vue&type=style&index=2&id=483bf53a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bf53a",
  null
  
)

export default component.exports